module.exports = __webpack_public_path__ + "img/smart-license.6f0a806a.svg";